import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const dbtCloud = defineConnector({
  identifier: "dbtCloud",
  name: "dbt Cloud",
  tagLine: "Data transformation and modeling platform",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: ({ accessUrl }) => domainToRegex(accessUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a dbt API token",
      items: [
        {
          kind: "markdown",
          content:
            "In dbt, go to **Account settings** and create a **Service Token** for production integrations or a **Personal Access Token** for development use. Copy the token value, your account ID, and your account access URL.",
        },
      ],
    },
    {
      title: "Enter your dbt Cloud details",
      items: [
        {
          kind: "url",
          label: "Access URL",
          required: true,
          defaultValue: "https://cloud.getdbt.com",
          placeholder: "https://cloud.getdbt.com",
          target: { kind: "configuration", field: "accessUrl" },
          helperText:
            "Use your dbt account access URL. Multi-tenant, regional, and single-tenant accounts can use different hosts.",
        },
        {
          kind: "input",
          label: "Account ID",
          required: true,
          placeholder: "12345",
          target: { kind: "configuration", field: "accountId" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ accessUrl, accountId }) => ({
      url: `${accessUrl}/api/v2/accounts/${accountId}/projects/`,
      expectedStatus: [200, 403],
    }),
  },
});
